
export default {
  filters: {
    number: value => isNaN(value) ? value : Intl.NumberFormat().format(value),
  },
  props: {
    checkedList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  emits: ['delete'],
  setup (_props, { emit }) {
    const deleteBubble = value => emit('delete', value)
    return { deleteBubble }
  },
}
